export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6065.82541c41.jpg";